import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

/** Wire shape of GET/POST v2/accounting/coa/needs-correction[/recheck] (R74e). */
export interface AccountCorrectionStatus {
  needed: boolean;
  /** POOJA_DATES | HEAD_REMAP | DUPLICATE_GROUPS | VOUCHER_BACKFILL. */
  reasons: string[];
  /** true when the server ran the detection sweep for this response. */
  evaluated: boolean;
}

/**
 * R74e — the NEEDS_ACCOUNT_CORRECTION flag client (root-injectable, unlike the
 * page-provided CoaMergeApiService, because the LOGIN flow reads it too).
 * `get()` is a single cached-flag read on the server (the expensive detection
 * sweep ran once at the first boot after the migration — the owner's
 * login-performance trick), so calling it after every login costs nothing.
 * `recheck()` re-runs the sweep — the Account Corrections window calls it
 * after each corrective action so the flag flips to false when all clean.
 */
@Injectable({ providedIn: 'root' })
export class AccountCorrectionCheckService {
  private readonly http = inject(HttpClient);

  /** Roles that can act on the corrections window (server guard mirror). */
  static readonly CORRECTION_ROLES = [
    'ACCOUNT', 'ACCOUNT_FULL_ACCESS', 'ACCOUNTING_FULL_ACCESS',
    'TEMPLE_ADMIN', 'FULL_ACCESS', 'COMPANY_ACCESS',
  ];

  get(): Observable<any> {
    return this.http.get<any>('v2/accounting/coa/needs-correction');
  }

  recheck(): Observable<any> {
    return this.http.post<any>('v2/accounting/coa/needs-correction/recheck', {});
  }
}
